export const headlineTemplate = `
    <div class="pl_table-view--headline squirrel_searchSuggestions__headline js_squirrel_ignore_close_suggest squirrel_border_top"
         style="display: flex; align-items: center;">
        <span class="pl_copy75 js_squirrel_ignore_close_suggest"
              style="flex: 0 0 50%; padding-right: 8px;">DEINE SUCHHISTORIE</span>
        <span class="pl_link100--primary js_squirrel_history_edit_button js_squirrel_ignore_close_suggest"
              style="flex: 0 0 50%; padding-left: 8px; text-align: right;" data-qa-id="search-history-edit">
            {{^selectMode}}{{labelEdit}}{{/selectMode}}
            {{#selectMode}}{{labelAbort}}{{/selectMode}}
        </span>
    </div>
`;

export const checkboxIconTemplate = `
    <svg class="pl_icon" role="img" width="24" height="24" style="flex: 0 0 24px;height:24px" viewBox="0 0 24 24" fill="none" xmlns="http:/*                   */
      <title>Deine vergangene Suche</title>
      <use xlink:href="/assets-static/icons/pl_icon_duration.svg#pl_icon_duration"/>
    </svg>
`;

export const checkboxInputTemplate = `
    <input type="checkbox" class="pl_checkbox__element js_squirrel_ignore_close_suggest js_squirrel_select_history_item" {{#checked}}checked{{/checked}} id="checkbox-default-unchecked"/>
`;

export const itemLabelTemplate = `
    <span data-term="{{term}}"
          data-target="{{target}}"
          class="squirrel_searchHistory__term
                 js_squirrel_searchHistory__term
                 js_squirrel_ignore_close_suggest"
          checked="{{checked}}"
          style="line-height: 0; display: flex; flex-direction: column">
          <span class="pl_copy100">{{term}}</span>
          </br>
          <span class="pl_copy75 squirrel_searchHistory__filter">{{activeFilters}}</span>
  </span>
`;

export const arrowTemplate = `
        <svg class="pl_icon100 squirrel_searchHistory__right-icon js_squirrel_ignore_close_suggest" role="img">
            <title>Suchergebnisse öffnen</title>
            <use xlink:href="/assets-static/icons/pl_icon_arrow-right.svg#pl_icon_arrow-right"/>
        </svg>
`;

export const keywordsTemplate = `
    {{#searches}}
    <li class="squirrel_searchHistory" data-qa-id="search-history">
        <div class="squirrel_searchHistory__text js_squirrel_searchHistory js_squirrel_ignore_close_suggest" 
            data-qa-id="search-suggest-text" data-historyIndex="{{historyIndex}}">
                {{>checkboxItem}}
                {{>itemLabelTemplate}}
                {{>arrowTemplate}}
        </div>
    </li>
    {{/searches}}
`;

export const footerLiTemplate = `
    <li class="squirrel_searchHistoryDelete js_squirrel_ignore_close_suggest">
        <div class="pl_table-view--item-fully-clickable js_squirrel_ignore_close_suggest">
            <div data-qa-id="search-history-delete" class="squirrel_searchHistoryDelete__text js_squirrel_searchHistoryDelete pl_link100--primary js_squirrel_ignore_close_suggest">
                <svg class="pl_icon js_squirrel_ignore_close_suggest" role="img" width="24" height="24"
                     style="flex: 0 0 24px;height:24px;margin-right: 16px"
                     viewBox="0 0 24 24" fill="none" xmlns="http:/*                   */
                    <use xlink:href="/assets-static/icons/pl_icon_delete.svg#pl_icon_delete"/>
                </svg>
                <span class="pl_copy100 squirrel_searchHistory__term js_squirrel_searchHistory__term js_squirrel_ignore_close_suggest">
                    {{label}}
                </span>
            </div>
        </div>
    </li>
`;
